<template>
<div>

<!-- MENU USUARIOS DE GRUPO TRANSPORTISTA -->
   <v-menu text nav v-if="(view_carta_porte == 1 || soloCartaPorte ) && view_catalogos_manifiesto " bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-list </v-icon>
                    <span class="caption">Administración</span>
                </v-btn>
            </template>

            <v-list :tile="false" nav>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.catalogos.receptores.crear') || valida_permiso_t('EmanifiestoCP.catalogos.receptores.consultar')" to="/carta_porte/catalogos/clientes" @click.shift="openNew('/carta_porte/catalogos/clientes');">
                    <v-icon>mdi-circle-small</v-icon>Receptores
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.catalogos.ubicaciones.crear') || valida_permiso_t('EmanifiestoCP.catalogos.ubicaciones.consultar')" to="/carta_porte/catalogos/ubicaciones" @click.shift="openNew('/carta_porte/catalogos/ubicaciones');">
                    <v-icon>mdi-circle-small</v-icon>Ubicaciones
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.catalogos.servicios.crear') || valida_permiso_t('EmanifiestoCP.catalogos.servicios.consultar')" to="/carta_porte/catalogos/productos" @click.shift="openNew('/carta_porte/catalogos/productos');">
                    <v-icon>mdi-circle-small</v-icon>Servicios
                </app-bar-item>
                 <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.catalogos.productos.crear') || valida_permiso_t('EmanifiestoCP.catalogos.productos.consultar')" to="/carta_porte/catalogos/materiales" @click.shift="openNew('/carta_porte/catalogos/materiales');">
                    <v-icon>mdi-circle-small</v-icon>Productos y Mercancias
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.catalogos.figuras.crear') || valida_permiso_t('EmanifiestoCP.catalogos.figuras.consultar')" to="/carta_porte/catalogos/figuras_transporte" @click.shift="openNew('/carta_porte/catalogos/figuras_transporte');">
                    <v-icon>mdi-circle-small</v-icon>Figuras Transporte
                </app-bar-item>
                 <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.catalogos.remolques.crear') || valida_permiso_t('EmanifiestoCP.catalogos.remolques.consultar')" to="/carta_porte/catalogos/remolques" @click.shift="openNew('/carta_porte/catalogos/remolques');">
                    <v-icon>mdi-circle-small</v-icon>Remolques
                </app-bar-item>
                    <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.catalogos.transportes.crear') || valida_permiso_t('EmanifiestoCP.catalogos.transportes.consultar')" to="/carta_porte/catalogos/transportes" @click.shift="openNew('/carta_porte/catalogos/transportes');">
                    <v-icon>mdi-circle-small</v-icon>Transportes
                </app-bar-item>
                <v-divider v-if="valida_permiso_t('EmanifiestoCP.catalogos.mercancias.consultar') || valida_permiso_t('EmanifiestoCP.catalogos.seguros.consultar')" />
                 <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.catalogos.mercancias.consultar')" to="/carta_porte/catalogos/materiales_grupo" @click.shift="openNew('/carta_porte/catalogos/materiales_grupo');">
                    <v-icon>mdi-circle-small</v-icon>Consulta base de clasificación Mercancías
                </app-bar-item>
                 <app-bar-item disabled v-if="valida_permiso_t('EmanifiestoCP.catalogos.seguros.consultar')" to="/carta_porte/reportes/seguros" @click.shift="openNew('/carta_porte/reportes/seguros');  ">
                    <v-icon>mdi-circle-small</v-icon>Consultar Seguros
                </app-bar-item>

                <v-divider />

                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.catalogos.sellos.editar')" to="/carta_porte/catalogos/registro_fiscal" @click.shift="openNew('/carta_porte/catalogos/registro_fiscal');">
                    <v-icon>mdi-circle-small</v-icon>Datos Fiscales
                </app-bar-item>
                 <app-bar-item  v-if="(valida_permiso_t('EmanifiestoCP.catalogos.usuarios.crear') || valida_permiso_t('EmanifiestoCP.catalogos.usuarios.consultar')) " to="/catalogos/usuarios" @click.shift="openNew('/catalogos/usuarios');">
                    <v-icon>mdi-circle-small</v-icon>Usuarios
                </app-bar-item>
              


            </v-list>
    </v-menu>
            <v-menu text nav v-if="(view_carta_porte == 1 || soloCartaPorte  ) && view_cfdi " bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-qrcode </v-icon>
                    <span class="caption">CFDI</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
                 <v-menu  v-if="valida_permiso_t('EmanifiestoCP.carta.porte.nueva') " open-on-hover offset-x nav transition="scale-transition">
                    <template v-slot:activator="{ attrs, on }">

                        <span v-on="on" id="menuCP">
                            <app-bar-item @click.native="hideMenuReportes">
                                <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Nueva Carta Porte
                                <v-icon>mdi-menu-right</v-icon>
                            </app-bar-item>
                        </span>
                    </template>
                    <v-list :tile="false" nav>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta">
                            <v-icon>mdi-circle-small</v-icon>Autotransporte
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta_maritima">
                            <v-icon>mdi-circle-small</v-icon>Marítimo
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta_aereo">
                            <v-icon>mdi-circle-small</v-icon>Aéreo
                        </app-bar-item>
                        <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/administrar/nueva_carta_ferroviaria">
                            <v-icon>mdi-circle-small</v-icon>Ferroviario
                        </app-bar-item>
                    </v-list>
                </v-menu>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.carta.porte.borradores')  " to="/carta_porte/administrar/borradores" @click.shift="openNew('/carta_porte/administrar/borradores');">
                    <v-icon>mdi-circle-small</v-icon>Borradores Carta Porte
                </app-bar-item>
                <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.carta.porte.refacturar')" to="/carta_porte/administrar/borradores_refacturar" @click.shift="openNew('/carta_porte/administrar/borradores_refacturar');">
                   <v-icon>mdi-circle-small</v-icon>Borradores Carta Porte Refacturación
               </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.carta.porte.consultar') " to="/carta_porte/administrar/cartas" @click.shift="openNew('/carta_porte/administrar/cartas');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Carta Porte
                </app-bar-item>
              <v-divider />
              <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.cfdi.nueva')" to="/carta_porte/administrar/comercio_exterior" @click.shift="openNew('/carta_porte/administrar/nueva_carta');">
                    <v-icon>mdi-circle-small</v-icon>Nuevo CFDI
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.cfdi.borradores')" to="/carta_porte/administrar/borradoresce" @click.shift="openNew('/carta_porte/administrar/borradoresce');">
                    <v-icon>mdi-circle-small</v-icon>Borradores CFDI
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.cfdi.consultar') " to="/carta_porte/administrar/comercio" @click.shift="openNew('/carta_porte/administrar/comercio');">
                    <v-icon>mdi-circle-small</v-icon>Consultar CFDI
                </app-bar-item>

            </v-list>
    </v-menu>
    <v-menu text nav v-if="(view_carta_porte == 1 || soloCartaPorte  ) && view_menu_carga" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-upload </v-icon>
                    <span class="caption">Carga de Información</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.archivom.cargar')" to="/ce_cargazip" @click.shift="openNew('/ce_cargazip');">
                    <v-icon>mdi-circle-small</v-icon>Carga Archivos M
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.archivom.consultar') " to="/ce_bitacora" @click.shift="openNew('/ce_bitacora');">
                    <v-icon>mdi-circle-small</v-icon>Bitácora Archivos M
                </app-bar-item>
                <v-divider />
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.facturas.cargar')" to="/ce_cargazipfacturas" @click.shift="openNew('/ce_cargazipfacturas');">
                    <v-icon>mdi-circle-small</v-icon>Carga ZIP CFDI
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.facturas.consultar')" to="/ce_facturastransito" @click.shift="openNew('/ce_facturastransito');">
                    <v-icon>mdi-circle-small</v-icon>Bitáctora CFDI
                </app-bar-item>


            </v-list>
    </v-menu>
     <v-menu text nav v-if="(view_carta_porte == 1 || soloCartaPorte ) && view_menu_edrive_emanifiesto" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>account_tree </v-icon>
                    <span class="caption">eDrive</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>

                <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.edrive.consultar')" to="/edrivet" @click.shift="openNew('/edrivet');">
                    <v-icon>mdi-circle-small</v-icon>Consultar Expediente
                </app-bar-item>
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.edrive.descargar')" to="/ce_expedientem" @click.shift="openNew('/ce_expedientem');">
                    <v-icon>mdi-circle-small</v-icon>Descargar Expediente
                </app-bar-item>




            </v-list>
    </v-menu>
    <v-menu text nav v-if="(view_carta_porte == 1 || soloCartaPorte ) && view_menu_reportes_emanifiesto" bottom offset-y origin="center center" transition="scale-transition">
            <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>fa fa-file-excel</v-icon>
                    <span class="caption">Reportes</span>
                </v-btn>
            </template>
            <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.reportes.directom')"  to="/ce_directom" @click.shift="openNew('/ce_directom'); ">
                    <v-icon>mdi-circle-small</v-icon>Reporte Archivos M
                </app-bar-item>
                <v-divider />
                 <app-bar-item v-if="valida_permiso_t('EmanifiestoCP.reportes.comercio') "  to="/ce_reporteexterior" @click.shift="openNew('/ce_reporteexterior'); ">
                    <v-icon>mdi-circle-small</v-icon> Reporte CFDI Comercio Exterior
                </app-bar-item>
                <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.reportes.comercio.detalle') " to="/ce_reportedetalle" @click.shift="openNew('/ce_reportedetalle');">
                    <v-icon>mdi-circle-small</v-icon>Reporte CFDI Detallado
               </app-bar-item>
             
                <v-divider />
               <app-bar-item  v-if="valida_permiso_t('EmanifiestoCP.reportes.layout.cp') " to="/carta_porte/layoutcfdi" @click.shift="openNew('/carta_porte/layoutcfdi');">
                    <v-icon>mdi-circle-small</v-icon>Layout Carta Porte
               </app-bar-item>
                <v-divider />
                <app-bar-item to="/catalogos/etipsHTML" @click.shift="openNew('/catalogos/etipsHTML');">
                    <v-icon>mdi-circle-small</v-icon> Manual de Usuario
                </app-bar-item>

                <app-bar-item to="/videotutorial" @click.shift="openNew('/videotutorial');">
                    <v-icon>mdi-circle-small</v-icon>Consulta Video Tutoriales
                </app-bar-item>
            </v-list>
    </v-menu>



    <v-menu  v-if="(view_carta_porte == 1 || soloCartaPorte  ) && !es_transportista && !es_agente "  text nav bottom offset-y origin="center center" transition="scale-transition">
     <template v-slot:activator="{ attrs, on }">
                <v-btn text v-on="on">
                    <v-icon small>file_copy</v-icon>
                    <span class="caption">Insumos SAT</span>
                </v-btn>
            </template>

        <v-list :tile="false" nav>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/productos">
                <v-icon>mdi-circle-small</v-icon>Productos y Servicios
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/materiales_peligrosos">
                <v-icon>mdi-circle-small</v-icon>Materiales Peligrosos
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/embalajes">
                <v-icon>mdi-circle-small</v-icon>Tipos de Embalajes
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/config_auto">
                <v-icon>mdi-circle-small</v-icon>Configuración Vehicular
            </app-bar-item>
            <app-bar-item  @click.native="hideMenuReportes" to="/carta_porte/catalogos_sat/ubicaciones">
                <v-icon>mdi-circle-small</v-icon>Ubicaciones
            </app-bar-item>
        </v-list>
    </v-menu>


</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";



export default {
    name: "menuEmanifiestoCP",

  
    created() {

       
        this.$local_storage.set("es_emanifiesto_logistico", this.$local_storage.get("EmanifiestoCP.Logistica.bitacora") == 100);

    },
    components: {
   
        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",
        fullWidth: document.documentElement.clientWidth,
        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
       
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
      
        es_transportista() {
            return this.$local_storage.get("es_transportista")==1  && this.$local_storage.get("id_cliente") == 0;
        },
        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo"); ;
        },
        es_agente(){
            return this.$local_storage.get("es_agente")==1  && this.$local_storage.get("id_cliente") == 0 && this.$local_storage.get("id_grupo") > 0;
        },
        view_catalogos_manifiesto(){
            return (
                    this.valida_permiso_t("EmanifiestoCP.catalogos.clientes.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.clientes.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.usuarios.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.usuarios.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.sellos.editar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.receptores.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.receptores.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.ubicaciones.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.ubicaciones.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.servicios.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.servicios.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.productos.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.productos.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.mercancias.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.figuras.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.figuras.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.remolques.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.remolques.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.transportes.crear") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.transportes.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.catalogos.seguros.consultar")

            );
        },
        view_cfdi(){
             return (
                    this.valida_permiso_t("EmanifiestoCP.carta.porte.nueva") ||
                    this.valida_permiso_t("EmanifiestoCP.carta.porte.borradores") ||
                    this.valida_permiso_t("EmanifiestoCP.carta.porte.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.carta.porte.refacturar") ||
                    this.valida_permiso_t("EmanifiestoCP.cfdi.nueva") ||
                    this.valida_permiso_t("EmanifiestoCP.cfdi.borradores") ||
                    this.valida_permiso_t("EmanifiestoCP.cfdi.consultar")

            );
        },
        view_menu_carga(){
             return (
                    this.valida_permiso_t("EmanifiestoCP.archivom.cargar") ||
                    this.valida_permiso_t("EmanifiestoCP.archivom.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.facturas.cargar") ||
                    this.valida_permiso_t("EmanifiestoCP.facturas.consultar")
            );
        },
         view_menu_edrive_emanifiesto(){
             return (
                    this.valida_permiso_t("EmanifiestoCP.edrive.consultar") ||
                    this.valida_permiso_t("EmanifiestoCP.edrive.descargar")
            );
        },
         view_menu_reportes_emanifiesto(){
             return (
                    this.valida_permiso_t("EmanifiestoCP.reportes.directom") ||
                    this.valida_permiso_t("EmanifiestoCP.reportes.comercio") ||
                    this.valida_permiso_t("EmanifiestoCP.reportes.comercio.detalle") ||
                    this.valida_permiso_t("EmanifiestoCP.reportes.layout.cp")
             );
        },
        view_carta_porte() {
            return this.$store.state.carta_porte;
        },
        soloCartaPorte(){
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
        esGrupo(){
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0
            );
        },
        valida_permiso_t(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 
            );
        },
    
        openNew: function (h) {
            window.open(h, "_blank");
        },
       
        hideMenuReportes: function () {

          
            var menu6 = document.getElementById("menuCP");

        
            if (menu6) {
                menu6.click();
            }
        },
    },
 
};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
